/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIWidget } from '@/models/api/widget.model'

const resource = {
    main: 'services',
    module: 'widgets'
}

export class WidgetsServices {
    public static getWidgets () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getWidgetsPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getWidgetsById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createWidgets (params: APIWidget) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editWidgets (params: APIWidget) {
        return service.put(`${resource.main}/${resource.module}/${params.widgetId}`, params)
    }

    public static deleteWidgets (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
